import React, { useEffect, useState, useCallback } from 'react';
import { FlyingConfig } from '../seasonConfig';
import './FlyingElement.css';

interface FlyingElementProps {
    config: FlyingConfig;
}

type Direction = 'left-to-right' | 'right-to-left';

const FlyingElement: React.FC<FlyingElementProps> = ({ config }) => {
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState({ top: 20 });
    const [direction, setDirection] = useState<Direction>('left-to-right');

    const showElement = useCallback(() => {
        // Random vertical position (10% to 40% from top)
        setPosition({ top: 10 + Math.random() * 30 });
        // Random direction
        setDirection(Math.random() > 0.5 ? 'left-to-right' : 'right-to-left');
        setVisible(true);

        // Hide after animation completes
        setTimeout(() => {
            setVisible(false);
        }, config.speed * 1000);
    }, [config.speed]);

    useEffect(() => {
        // Show element after initial delay (5-15 seconds)
        const initialDelay = 5000 + Math.random() * 10000;
        const initialTimer = setTimeout(showElement, initialDelay);

        // Then show element periodically based on frequency
        const interval = setInterval(() => {
            if (!visible) {
                showElement();
            }
        }, config.frequency * 1000);

        return () => {
            clearTimeout(initialTimer);
            clearInterval(interval);
        };
    }, [config.frequency, showElement, visible]);

    if (!visible) return null;

    return (
        <div
            className={`flying-element flying-element--${direction}`}
            style={{
                top: `${position.top}%`,
                '--fly-speed': `${config.speed}s`,
            } as React.CSSProperties}
        >
            <div className="flying-element__content">
                {config.emoji}
            </div>
        </div>
    );
};

export default FlyingElement;
